import { z } from 'zod'
import { workTagSchema } from './work-tags'

/** The anonymous directory includes only public open work and display fields. */
export const publicWorkListSchema = z.object({
  items: z.array(z.object({
    id: z.string().uuid(),
    title: z.string().max(180),
    kind: z.enum(['task', 'shard', 'audit', 'experiment', 'question', 'replication']),
    status: z.literal('open'),
    activeClaims: z.number().int().nonnegative(),
    evidenceCount: z.number().int().nonnegative(),
    tags: z.array(workTagSchema).max(8),
  })).max(100),
  nextCursor: z.string().uuid().nullable(),
})
export type PublicWorkList = z.infer<typeof publicWorkListSchema>
